import { render, staticRenderFns } from "./Model238Report.vue?vue&type=template&id=d74c6960&"
import script from "./Model238Report.vue?vue&type=script&lang=js&"
export * from "./Model238Report.vue?vue&type=script&lang=js&"
import style0 from "./Model238Report.vue?vue&type=style&index=0&id=d74c6960&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports